export const config = {
    home: {
        desc: `Opis „Strony głównej” dla czytnika ekranu. Na tej stronie znajdziesz wyszukiwarkę zasobów DBW oraz sekcję z wykresami podzielonymi na cztery kategorie: „Popularne”, „Gospodarka”, „Społeczeństwo” oraz „Środowisko”.`,
        desc_en: `Description of the „Homepage” for screen reader. On this page, you will find the Knowledge Databases resource search engine and a section with charts divided into four categories: "Popular", "Economy", "Society" and "Environment".`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#main_search_bar_input",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#home_areas_prsentation",
                focus: "button",
                label: "Przejdź do sekcji z wykresami",
                label_en: "Go to the section with charts",
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Strona główna - DBW",
        h1_en: "Homepage - Knowledge Databases",
        head: {
            title: "Strona główna | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz wyszukiwarkę zasobów DBW oraz sekcję z wykresami podzielonymi na cztery kategorie: „Popularne”, „Gospodarka”, „Społeczeństwo” oraz „Środowisko”.`,
        },
        head_en: {
            title: "Homepage | Knowledge Databases",
            metaDesc: `On this page, you will find the Knowledge Databases resource search engine and a section with charts divided into four categories: "Popular", "Economy", "Society" and "Environment".`,
        },
    },
    search: {
        desc: `Opis strony „Wyniki wyszukiwania” dla czytnika ekranu. Na tej stronie znajdziesz wyszukiwarkę zasobów DBW, sekcję z filtrami wyników wyszukiwania oraz sekcję z wynikami wyszukiwania.`,
        desc_en: `Description of the „Search results” page for screen reader. On this page, you will find the Knowledge Databases resource search engine, a section with search results filters, and a section displaying search results.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#main_search_bar_input",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#search-results-filters-title",
                label: "Przejdź do filtrów wyników wyszukiwania",
                label_en: "Go to search result filters",
            },
            {
                id: 4,
                href: "#search-results-results-title",
                label: "Przejdź do wyników wyszukiwania",
                label_en: "Go to search results",
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Wyniki wyszukiwania - DBW",
        h1_en: "Search results | Knowledge Databases",
        head: {
            title: "Wyniki wyszukiwania | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz wyszukiwarkę zasobów DBW, sekcję z filtrami wyników wyszukiwania oraz sekcję z wynikami wyszukiwania.`,
        },
        head_en: {
            title: "Search results | Knowledge Databases",
            metaDesc: `On this page, you will find the Knowledge Databases resource search engine, a section with search results filters, and a section displaying search results.`,
        },
    },
    dbStart: {
        desc: `Opis strony „Wybór danych - Baza danych” dla czytnika ekranu. Na tej stronie znajdziesz wyszukiwarkę danych oraz drzewko wyboru danych. Ponadto znajduje się tu sekcja z czterema krokami, które w krótki sposób opisują proces generowania i modyfikowania zestawienia.`,
        desc_en: `Description of the „Data selection - Database” page for screen reader. On this page, you will find the data search engine and the data selection tree. Moreover, there is a section with four steps that briefly describe the process of generating and modifying a summary.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#search-indicator",
                label: "Przejdź do wyboru danych - wyszukiwarka",
                label_en: "Go to the data selection - search engine",
            },
            {
                id: 4,
                href: "#indicators-tree",
                focus: "li",
                label: "Przejdź do wyboru danych - drzewko",
                label_en: "Go to the data selection - tree",
            },
            {
                id: 5,
                href: "#db-howto-steps",
                label: "Przejdź do opisu czterech kroków",
                label_en: "Go to the four steps description",
            },
            // {
            //     id: 6,
            //     href: "#repository-actions",
            //     label: "Przejdź do operacji z repozytorium ",
            //     label_en: "Go to actions with repository ",
            // },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Wybór danych - Baza danych - DBW",
        h1_en: "Data selection - Database - Knowledge Databases",
        head: {
            title: "Wybór danych - Baza danych | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz wyszukiwarkę danych oraz drzewko wyboru danych. Ponadto znajduje się tu sekcja z czterema krokami, które w krótki sposób opisują proces generowania i modyfikowania zestawienia.`,
        },
        head_en: {
            title: "Data selection - Database | Knowledge Databases",
            metaDesc: `On this page, you will find the data search engine and the data selection tree. Moreover, there is a section with four steps that briefly describe the process of generating and modifying a summary.`,
        },
    },
    dbFull: {
        desc: `Opis strony „Baza danych” dla czytnika ekranu. Na tej stronie znajdziesz komponenty umożliwiające zmianę szeregu czasowego oraz jednostki terytorialnej. Ponadto znajduje się tu sekcja z wybranymi wcześniej zmiennymi oraz sekcja z wyborem zaawansowanym, gdzie można zmienić ustawienia związane z przekrojem, typem informacji i pozycjami wybranych wymiarów. Na samym dole znajduje się wygenerowana tablica z danymi. Jest również możliwość przejścia do panelu wyboru danych.`,
        desc_en: `Description of the „Database” page for screen reader. On this page you will find components enabling the change of the time series and the territorial unit. Moreover, there is a section with previously selected variables and an advanced selection section where you can change settings related to the cross-section, information type and positions of selected dimensions. At the bottom, there is a generated table with data. On this page, there is also an option to navigate to the data selection panel.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#db-left-panel-open-close-btn",
                label: "Przejdź do panelu wyboru danych",
                label_en: "Go to the data selection panel",
            },
            {
                id: 4,
                href: "#db-time-series-btn",
                label: "Przejdź do wyboru szeregu czasowego i jednostki terytorialnej oraz do sekcji z wybranymi zmiennymi",
                label_en:
                    "Go to the time series and the territorial unit selection, and to the section with selected variables",
            },
            // {
            //     id: 5,
            //     href: "#repository-actions",
            //     label: "Przejdź do operacji z repozytorium ",
            //     label_en: "Go to actions with repository ",
            // },
            {
                id: 6,
                href: "#db-advanced-filters-btn",
                label: "Przejdź do wyboru zaawansowanego",
                label_en: "Go to the advanced selection",
            },
            {
                id: 7,
                href: "#db-table-title",
                label: "Przejdź do tablicy",
                label_en: "Go to the table",
            },

            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Baza danych - DBW",
        h1_en: "Database - Knowledge Databases",
        head: {
            title: "Baza danych | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz komponenty umożliwiające zmianę szeregu czasowego oraz jednostki terytorialnej. Ponadto znajduje się tu sekcja z wybranymi wcześniej zmiennymi oraz sekcja z wyborem zaawansowanym, gdzie można zmienić ustawienia związane z przekrojem, typem informacji i pozycjami wybranych wymiarów. Na samym dole znajduje się wygenerowana tablica z danymi. Jest również możliwość przejścia do panelu wyboru danych.`,
        },
        head_en: {
            title: "Database | Knowledge Databases",
            metaDesc: `On this page you will find components enabling the change of the time series and the territorial unit. Moreover, there is a section with previously selected variables and an advanced selection section where you can change settings related to the cross-section, information type and positions of selected dimensions. At the bottom, there is a generated table with data. On this page, there is also an option to navigate to the data selection panel.`,
        },
    },
    dashboard: {
        desc: `Na tej stronie znajdziesz dwie sekcje. Górna sekcja prezentuje wartości dla trzech wskaźników oraz wykresy powiązane z wybranym rodzajem dashboardu. Dolna sekcja również prezentuje wykresy powiązane z wybranym rodzajem dashboardu, ale w tym przypadku zostały one podzielone na grupy. Każda grupa posiada odpowiedni opis.`,
        desc_en: `On this page you will find two sections. The top section presents values for three indicators and charts related to the selected type of dashboard. The bottom section also presents charts related to the selected type of dashboard, but in this case, they are divided into groups. Each group has a corresponding description.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#dashboard-main-title",
                label: "Przejdź do górnej sekcji dashboardu",
                label_en: "Go to the top section of the dashboard",
            },
            {
                id: 4,
                href: "#dashboard-main-content",
                focus: "#dashboard-main-content-0-title",
                label: "Przejdź do dolnej sekcji dashboardu",
                label_en: "Go to the bottom section of the dashboard",
                rescroll: true,
            },

            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: " - Dashboardy - DBW",
        h1_en: " - Dashboards - Knowledge Databases",
        head: {
            title: " - Dashboardy | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz dwie sekcje. Górna sekcja prezentuje wartości dla trzech wskaźników oraz wykresy powiązane z wybranym rodzajem dashboardu. Dolna sekcja również prezentuje wykresy powiązane z wybranym rodzajem dashboardu, ale w tym przypadku zostały one podzielone na grupy. Każda grupa posiada odpowiedni opis.`,
        },
        head_en: {
            title: " - Dashboards | Knowledge Databases",
            metaDesc: `On this page you will find two sections. The top section presents values for three indicators and charts related to the selected type of dashboard. The bottom section also presents charts related to the selected type of dashboard, but in this case, they are divided into groups. Each group has a corresponding description.`,
        },
    },
    hvd: {
        desc: `Opis strony „Dane o wysokiej wartości (HVD)” dla czytnika ekranu. Na tej stronie znajdziesz tabele z plikami do pobrania w formatach CSV i XLSX, które zawierają dane o wysokiej wartości oraz słowniki. Pliki powiązane są z konkretnymi wskaźnikami, które zostały pogrupowane w odpowiednie kategorie.`,
        desc_en: `Description of the „High-value datasets (HVD)” page for screen reader. On this page, you will find tables with files available for download in CSV and XLSX formats, containing High-value datasets and dictionaries. The files are associated with specific indicators that have been grouped into appropriate categories.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#hvd-main-title",
                label: "Przejdź do danych o wysokiej wartości",
                label_en: "Go to the high-value datasets",
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Dane o wysokiej wartości (HVD) - DBW",
        h1_en: "High-value datasets (HVD) - Knowledge Databases",
        head: {
            title: "Dane o wysokiej wartości (HVD) | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz tabele z plikami do pobrania w formatach CSV i XLSX, które zawierają dane o wysokiej wartości oraz słowniki. Pliki powiązane są z konkretnymi wskaźnikami, które zostały pogrupowane w odpowiednie kategorie.`,
        },
        head_en: {
            title: "High-value datasets (HVD) | Knowledge Databases",
            metaDesc: `On this page, you will find tables with files available for download in CSV and XLSX formats, containing High-value datasets and dictionaries. The files are associated with specific indicators that have been grouped into appropriate categories.`,
        },
    },
    valorizationStart: {
        desc: `Opis strony „Wybór typu kontraktu - Dane do waloryzacji” dla czytnika ekranu. Na tej stronie znajdziesz drzewko wyboru typu kontraktu. Pamiętaj, że wybierając pozycję „Umowy w zakresie inwestycji telekomunikacyjnych” zostaniesz przeniesiony do strony „Baza danych - Wybór danych”, a drzewko wyboru będzie rozwinięte do poziomu „Umowy w zakresie inwestycji telekomunikacyjnych”. Ponadto znajduje się tu sekcja z czterema krokami, które w krótki sposób opisują proces generowania i modyfikowania zestawienia.`,
        desc_en: `Description of the „Contract type selection - Data for indexation” page for screen reader. On this page, you will find the contract type selection tree. Remember that if you choose „Telecommunications investments contracts", you will be redirected to the „Database - Data selection” page, and the selection tree will expand to the „Telecommunications investments contracts” level. Moreover, there is a section with four steps that briefly describe the process of generating and modifying a summary.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#kalkulators-tree",
                focus: "li",
                label: "Przejdź do wyboru typu kontraktu",
                label_en: "Go to the contract type selection",
            },
            {
                id: 4,
                href: "#catalog-steps-intro",
                label: "Przejdź do opisu czterech kroków",
                label_en: "Go to the four steps description",
            },

            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Wybór typu kontraktu - Dane do waloryzacji - DBW",
        h1_en: "Contract type selection - Data for indexation - Knowledge Databases",
        head: {
            title: "Wybór typu kontraktu - Dane do waloryzacji | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz drzewko wyboru typu kontraktu. Pamiętaj, że wybierając pozycję „Umowy w zakresie inwestycji telekomunikacyjnych” zostaniesz przeniesiony do strony „Baza danych - Wybór danych”, a drzewko wyboru będzie rozwinięte do poziomu „Umowy w zakresie inwestycji telekomunikacyjnych”. Ponadto znajduje się tu sekcja z czterema krokami, które w krótki sposób opisują proces generowania i modyfikowania zestawienia.`,
        },
        head_en: {
            title: "Contract type selection - Data for indexation | Knowledge Databases",
            metaDesc: `On this page, you will find the contract type selection tree. Remember that if you choose „Telecommunications investments contracts", you will be redirected to the „Database - Data selection” page, and the selection tree will expand to the „Telecommunications investments contracts” level. Moreover, there is a section with four steps that briefly describe the process of generating and modifying a summary.`,
        },
    },
    valorizationFull: {
        desc: `Na tej stronie znajdziesz komponenty umożliwiające wybór szeregu czasowego i kwoty podlegającej waloryzacji. Ponadto znajduje się tu sekcja z parametrami, które możesz zmienić. Na samym dole znajduje się wygenerowana tablica z danymi. Jest również możliwość przejścia do panelu wyboru typu kontraktu.`,
        desc_en: `On this page, you will find components enabling selection of the time series and the value subject to indexation. Moreover, there is a section with parameters that you can modify. At the bottom, there is a generated table with data. On this page, there is also an option to navigate to the contract type selection panel.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#catalog-left-panel-open-close-btn",
                label: "Przejdź do panelu wyboru typu kontraktu",
                label_en: "Go to the contract type selection panel",
            },
            {
                id: 4,
                href: "#from-date-selector",
                label: "Przejdź do wyboru szeregu czasowego i kwoty podlegającej waloryzacji",
                label_en: "Go to the time series selection and the value subject to indexation",
            },
            {
                id: 5,
                href: "#catalog-params-btn",
                label: "Przejdź do wyboru parametrów",
                label_en: "Go to the parameters selection",
            },
            {
                id: 6,
                href: "#catalog-results-title",
                label: "Przejdź do tablicy",
                label_en: "Go to the table",
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: " - Dane do waloryzacji - DBW",
        h1_en: " - Data for indexation - Knowledge Databases",
        head: {
            title: " - Dane do waloryzacji | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz komponenty umożliwiające wybór szeregu czasowego i kwoty podlegającej waloryzacji. Ponadto znajduje się tu sekcja z parametrami, które możesz zmienić. Na samym dole znajduje się wygenerowana tablica z danymi. Jest również możliwość przejścia do panelu wyboru typu kontraktu.`,
        },
        head_en: {
            title: " - Data for indexation | Knowledge Databases",
            metaDesc: `On this page, you will find components enabling selection of the time series and the value subject to indexation. Moreover, there is a section with parameters that you can modify. At the bottom, there is a generated table with data. On this page, there is also an option to navigate to the contract type selection panel.`,
        },
    },
    calendar: {
        desc: `Opis strony „Kalendarium” dla czytnika ekranu. Na tej stronie znajdziesz sekcję z filtrami harmonogramu oraz harmonogram aktualizacji danych, który możesz pobrać w postaci pliku XLSX lub dodać go do kalendarza (ICS).`,
        desc_en: `Description of the „Calendar” page for screen reader. On this page, you will find a section with schedule filters and the data update schedule, which you can download as an XLSX file or add to your calendar (ICS).`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#calendar-filters-collapse-btn",
                label: "Przejdź do filtrów harmonogramu",
                label_en: "Go to the schedule filters",
            },
            {
                id: 4,
                href: "#calendar-get-xlsx-btn",
                label: "Przejdź do harmonogramu",
                label_en: "Go to the schedule",
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Kalendarium - DBW",
        h1_en: "Calendar - Knowledge Databases",
        head: {
            title: "Kalendarium | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz sekcję z filtrami harmonogramu oraz harmonogram aktualizacji danych, który możesz pobrać w postaci pliku XLSX lub dodać go do kalendarza (ICS).`,
        },
        head_en: {
            title: "Calendar | Knowledge Databases",
            metaDesc: `On this page, you will find a section with schedule filters and the data update schedule, which you can download as an XLSX file or add to your calendar (ICS).`,
        },
    },
    help: {
        desc: `Opis strony „Pomoc” dla czytnika ekranu. Na tej stronie znajdziesz sekcję ze wskazówkami dla użytkownika oraz sekcję z najczęściej zadawanymi pytaniami.`,
        desc_en: `Description of the „Help” page for screen reader. On this page, you will find a section with user instructions and a section with frequently asked questions.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#help-guide-title",
                label: "Przejdź do wskazówek dla użytkownika",
                label_en: "Go to the user guide",
            },
            {
                id: 4,
                href: "#help-faq-title",
                label: "Przejdź do najczęściej zadawanych pytań",
                label_en: "Go to the frequently asked questions",
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Pomoc - DBW",
        h1_en: "Help - Knowledge Databases",
        head: {
            title: "Pomoc | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz sekcję ze wskazówkami dla użytkownika oraz sekcję z najczęściej zadawanymi pytaniami.`,
        },
        head_en: {
            title: "Help | Knowledge Databases",
            metaDesc: `On this page, you will find a section with user instructions and a section with frequently asked questions.`,
        },
    },
    contact: {
        desc: `Opis strony „Kontakt” dla czytnika ekranu. Na tej stronie znajdziesz sekcję zatytułowaną „Skontaktuj się z nami”, sekcję z mapą oraz sekcję z formularzem kontaktowym.`,
        desc_en: `Description of the „Contact” page for screen reader. On this page, you will find a section titled „Contact us”, a section with a map and a section with a contact form.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#contacts-address-title",
                label: 'Przejdź do sekcji "Skontaktuj się z nami"',
                label_en: "Go to the 'Contact us' section",
            },
            {
                id: 4,
                href: "#contacts-map-iframe",
                label: "Przejdź do mapy",
                label_en: "Go to the map",
            },
            {
                id: 5,
                href: "#contacts-contact-form-title",
                label: "Przejdź do formularza kontaktowego",
                label_en: "Go to the contact form",
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Kontakt - DBW",
        h1_en: "Contact - Knowledge Databases",
        head: {
            title: "Kontakt | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz sekcję zatytułowaną „Skontaktuj się z nami”, sekcję z mapą oraz sekcję z formularzem kontaktowym.`,
        },
        head_en: {
            title: "Contact | Knowledge Databases",
            metaDesc: `On this page, you will find a section titled „Contact us”, a section with a map and a section with a contact form.`,
        },
    },
    declaration: {
        desc: "",
        desc_en: "",
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Deklaracja dostępności - DBW",
        h1_en: "Accessibility declaration - Knowledge Databases",
        head: {
            title: "Deklaracja dostępności | Dziedzinowe Bazy Wiedzy",
            metaDesc: "",
        },
        head_en: {
            title: "Accessibility declaration | Knowledge Databases",
            metaDesc: "",
        },
    },
    aggregatesStart: {
        desc: `Opis strony „Wybór danych - Pobieranie zbiorcze” dla czytnika ekranu. Na tej stronie znajdziesz wyszukiwarkę danych oraz drzewko wyboru danych. Ponadto znajduje się tu sekcja z trzema krokami, które w krótki sposób opisują jak działa pobieranie zbiorcze.`,
        desc_en: `Description of the „Data selection - Bulk download - Knowledge Databases” page for screen reader. On this page, you will find the data search engine and the data selection tree. Moreover, there is a section with three steps that briefly describe how bulk download works.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#search-indicator",
                label: "Przejdź do wyboru danych - wyszukiwarka",
                label_en: "Go to the data selection - search engine",
            },
            {
                id: 4,
                href: "#indicators-tree",
                focus: "li",
                label: "Przejdź do wyboru danych - drzewko",
                label_en: "Go to the data selection - tree",
            },
            {
                id: 5,
                href: "#aggregates-howto-steps",
                label: "Przejdź do opisu trzech kroków",
                label_en: "Go to the three steps description",
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Wybór danych - Pobieranie zbiorcze - DBW",
        h1_en: "Data selection - Bulk download - Knowledge Databases",
        head: {
            title: "Wybór danych - Pobieranie zbiorcze | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz wyszukiwarkę danych oraz drzewko wyboru danych. Ponadto znajduje się tu sekcja z trzema krokami, które w krótki sposób opisują jak działa pobieranie zbiorcze.`,
        },
        head_en: {
            title: "Data selection - Bulk download - Knowledge Databases",
            metaDesc: `On this page, you will find the data search engine and the data selection tree. Moreover, there is a section with three steps that briefly describe how bulk download works.`,
        },
    },
    aggregatesFull: {
        desc: `Na tej stronie znajdziesz tabelę z danymi do pobrania zbiorczego. Jest również możliwość przejścia do panelu wyboru danych.`,
        desc_en: `On this page, you will find a table with data available for bulk download. There is also an option to navigate to the data selection panel.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#aggregates-left-panel-open-close-btn",
                label: "Przejdź do panelu wyboru danych",
                label_en: "Go to the data selection panel",
            },
            // {
            //     id: 5,
            //     href: "#aggregates-certificate",
            //     label: "Przejdź do metryczky",
            //     label_en: "Go to the certificate",
            //     hide_when_error: true,
            // },
            {
                id: 6,
                href: "#aggregates-table-title",
                label: "Przejdź do pobierania zbiorczego",
                label_en: "Go to the bulk download",
                hide_when_error: true,
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: " - Pobieranie zbiorcze - DBW",
        h1_en: " - Bulk download - Knowledge Databases",
        head: {
            title: " - Pobieranie zbiorcze | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz tabelę z danymi do pobrania zbiorczego. Jest również możliwość przejścia do panelu wyboru danych.`,
        },
        head_en: {
            title: " - Bulk download | Knowledge Databases",
            metaDesc: `On this page, you will find a table with data available for bulk download. There is also an option to navigate to the data selection panel.`,
        },
    },
    repository: {
        desc: `Opis strony „Repozytorium” dla czytnika ekranu.`,
        desc_en: `Description of the „Repository” page for screen reader.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#repository-content",
                label: "Przejdź do zestawień repozytorium",
                label_en: "Go to repository statements",
            },

            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Repozytorium - DBW",
        h1_en: "Repository - Knowledge Databases",
        head: {
            title: "Repozytorium | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Opis strony „Repozytorium” dla czytnika ekranu.`,
        },
        head_en: {
            title: "Repository | Knowledge Databases",
            metaDesc: `Description of the „Repository” page for screen reader.`,
        },
    },
    account: {
        desc: `Opis strony „Konto” dla czytnika ekranu.`,
        desc_en: `Description of the „Account” page for screen reader.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },

            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Konto - DBW",
        h1_en: "Account - Knowledge Databases",
        head: {
            title: "Konto | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Opis strony „Konto” dla czytnika ekranu.`,
        },
        head_en: {
            title: "Account | Knowledge Databases",
            metaDesc: `Description of the „Account” page for screen reader.`,
        },
    },
    metaStart: {
        desc: `Opis strony „Wybór danych - Metadane” dla czytnika ekranu.`,
        desc_en: `Description of the „Data selection - Metadata” page for screen reader.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },

            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Wybór danych - Metadane - DBW",
        h1_en: "Data selection - Metadata - Knowledge Databases",
        head: {
            title: "Wybór danych - Metadane | Dziedzinowe Bazy Wiedzy",
            metaDesc: "",
        },
        head_en: {
            title: "Data selection - Metadata - Knowledge Databases",
            metaDesc: "",
        },
    },
    metaFull: {        
        desc: `Opis strony „Metadane” dla czytnika ekranu.`,
        desc_en: `Description of the „Metadata” page for screen reader.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },

            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: " - Metadane - DBW",
        h1_en: " - Metadata - Knowledge Databases",
        head: {
            title: " - Metadane | Dziedzinowe Bazy Wiedzy",
            metaDesc: "",
        },
        head_en: {
            title: " - Metadata | Knowledge Databases",
            metaDesc: "",
        },
    },
    terms: {
        desc: `Opis strony „Warunki wykorzystywania” dla czytnika ekranu. Na tej stronie znajdziesz warunki wykorzystywania danych oraz geometrii granic map świata i Europy opublikowanych na stronach Dziedzinowych Baz Wiedzy.`,
        desc_en: `Description of the „Terms of use” page for screen reader. On this page, you will find the terms of use for data and boundaries geometry of world and Europe maps published on the Knowledge Databases pages.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#terms-of-use-title",
                label: "Przejdź do warunków wykorzystywania",
                label_en: "Go to the terms of use",
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Warunki wykorzystywania - DBW",
        h1_en: "Terms of use - Knowledge Databases",
        head: {
            title: "Warunki wykorzystywania | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz warunki wykorzystywania danych oraz geometrii granic map świata i Europy opublikowanych na stronach Dziedzinowych Baz Wiedzy.`,
        },
        head_en: {
            title: "Terms of use | Knowledge Databases",
            metaDesc: `On this page, you will find the terms of use for data and boundaries geometry of world and Europe maps published on the Knowledge Databases pages.`,
        },
    },    
    sitemap: {
        desc: `Opis strony „Mapa strony” dla czytnika ekranu. Na tej stronie znajdziesz mapę Dziedzinowych Baz Wiedzy.`,
        desc_en: `Description of the „Site map” page for screen reader. On this page, you will find map of the Knowledge Databases.`,
        links: [
            {
                id: 1,
                href: "#mainmenu",
                focus: "a",
                label: "Przejdź do menu z nawigacją",
                label_en: "Go to the navigation menu",
            },
            {
                id: 2,
                href: "#mainmenu",
                focus: "#top-menu-search-item",
                label: "Przejdź do wyszukiwarki zasobów DBW",
                label_en: "Go to the Knowledge Databases resource search engine",
            },
            {
                id: 3,
                href: "#sitemap-of-use-title",
                label: "Przejdź do mapy strony",
                label_en: "Go to the site map",
            },
            {
                id: 999,
                href: "#main_footer",
                focus: "#footer-address",
                label: "Przejdź do stopki",
                label_en: "Go to the footer",
            },
        ],
        h1: "Mapa strony - DBW",
        h1_en: "Site map - Knowledge Databases",
        head: {
            title: "Mapa strony | Dziedzinowe Bazy Wiedzy",
            metaDesc: `Na tej stronie znajdziesz mapę Dziedzinowych Baz Wiedzy.`,
        },
        head_en: {
            title: "Site map | Knowledge Databases",
            metaDesc: `On this page, you will find map of the Knowledge Databases.`,
        },
    },
};
